import { render, staticRenderFns } from "./RoomsetEdition.vue?vue&type=template&id=3547e3ee&scoped=true&"
import script from "./RoomsetEdition.vue?vue&type=script&lang=js&"
export * from "./RoomsetEdition.vue?vue&type=script&lang=js&"
import style0 from "./RoomsetEdition.vue?vue&type=style&index=0&id=3547e3ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547e3ee",
  null
  
)

export default component.exports